// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as SeguimientoRouteImport } from './routes/seguimiento'
import { Route as AuthenticatedPanelRouteImport } from './routes/_authenticated/panel'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const SeguimientoRoute = SeguimientoRouteImport.update({
            id: '/seguimiento',path: '/seguimiento',getParentRoute: () => rootRouteImport
          })
const AuthenticatedPanelRoute = AuthenticatedPanelRouteImport.update({
            id: '/panel',path: '/panel',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedPanelRoute: AuthenticatedPanelRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,SeguimientoRoute: SeguimientoRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)